module.exports = __webpack_public_path__ + "img/20190820135142373.9599fc5d.png";